import moment from "moment";

/** Нормализация строки для нечувствительного к регистру/пробелам сравнения. */
export const norm = (value) => (value ?? "").toString().trim().toLowerCase();

/** Поиск элемента справочника по полю name. */
export const findByName = (list, name) => {
  if (!name || !Array.isArray(list)) return null;
  return list.find((item) => norm(item.name) === norm(name)) || null;
};

/** Парсинг даты из строки Excel в Date (несколько форматов). */
export const parseDate = (value) => {
  if (!value) return null;
  const parsed = moment(
    value,
    ["MM/DD/YYYY HH:mm:ss", "MM/DD/YYYY", "YYYY-MM-DD", moment.ISO_8601],
    true,
  );
  return parsed.isValid() ? parsed.toDate() : null;
};

/**
 * Поиск типа ТС из справочника по названию ("Рефрижератор") либо по value-коду
 * ("Refrizherator") — Excel-ответ присылает оба поля.
 */
export const findVehicleType = (list, name, value) => {
  if (!Array.isArray(list)) return null;
  return (
    findByName(list, name) ||
    findByName(list, value) ||
    list.find((item) => norm(item.value) === norm(value)) ||
    null
  );
};

/** Является ли тип транспорта рефрижератором (для обязательности температуры). */
export const isRefrigerator = (type) =>
  type?.value === "refrigerator" || norm(type?.name) === "рефрижератор";

/**
 * Единые правила валидации строки массового заказа по уже резолвнутым справочникам.
 * Возвращает объект ошибок (пустой объект = строка валидна).
 */
export const validateResolvedRow = ({ row, countryFrom, cityFrom, countryTo, cityTo, type, t }) => {
  const errors = {};

  if (!parseDate(row?.shippingDate)) errors.shippingDate = t("bulkCreate.validation.shippingDate");
  if (!countryFrom) errors.countryFrom = t("bulkCreate.validation.countryFrom");
  if (!cityFrom) errors.cityFrom = t("bulkCreate.validation.cityFrom");
  if (!norm(row?.addressFrom)) errors.addressFrom = t("bulkCreate.validation.addressFrom");
  if (!countryTo) errors.countryTo = t("bulkCreate.validation.countryTo");
  if (!cityTo) errors.cityTo = t("bulkCreate.validation.cityTo");
  if (!norm(row?.addressTo)) errors.addressTo = t("bulkCreate.validation.addressTo");
  if (!norm(row?.category) && !norm(row?.categoryName))
    errors.category = t("bulkCreate.validation.category");
  if (!type) errors.type = t("bulkCreate.validation.type");
  if (row?.weight === "" || row?.weight === null || row?.weight === undefined)
    errors.weight = t("bulkCreate.validation.weight");
  if (isRefrigerator(type) && !norm(row?.temperature))
    errors.temperature = t("bulkCreate.validation.temperature");
  if (!row?.tenderDateEnd)
    errors.tenderDateEnd = t("bulkCreate.validation.tenderDateEnd");

  return errors;
};
